import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

import withRouter from '../../organisms/withRouter';
import {NegativeButton} from './NegativeButton';

/**
 * @typedef BackButtonOption 「戻る」ボタンオプション
 * @property {object} props プロパティ
 * @property {function} [onClick] ボタン押下時の処理
 * @property {boolean} [isModified] 変更有フラグ
 * @property {boolean} [showWarning] 警告表示有無。true指定時、props.dirtyまたはisModifiedがtrueの際に警告ダイアログを表示する。
 * @property {object} [style] Style指定
 */

/**
 * 「戻る」ボタン。
 * @param {BackButtonOption} {props, onClick, isModified, showWarning, style} オプション
 * @return {JSX.Element} 「戻る」ボタン要素
 */
function BackButton(
    {
      props,
      onClick,
      onCheckGrid,
      isModified = false,
      showWarning = false,
      style = {},
      fullWidth,
      label= '戻る',
      returnPath='',
    }) {
  return (
    <NegativeButton
      id="btnNegativeButtonCancel"
      onClick={(event) => {
        let isGirdModified = false;
        if (onCheckGrid) {
          isGirdModified = onCheckGrid(event);
        }
        // reduxFormで検出した変更とreduxForm以外の変更をチェック
        // どちらかが変更あり(true)の場合、警告表示
        if (showWarning && (props.dirty || isModified || isGirdModified)) {
          props.doShowMessage({
            message: {
              id: 'BFY000002C',
            },
            action: async () => {
              if (onClick) {
                onClick(event);
              }

              back(props.navigate, returnPath);
            },
          });
          return;
        }

        if (onClick) {
          onClick(event);
        }

        back(props.navigate, returnPath);
      }}
      variant="contained"
      startIcon={<KeyboardReturnIcon />}
      size="large"
      props={props}
      style={style}
      fullWidth={fullWidth}
    >
      <span>{label}</span>
    </NegativeButton>
  );
};

/**
 * 戻る処理の実行。
 * @param {*} navigate useNavigate
 * @param {*} returnPath 遷移先
 */
function back(navigate, returnPath) {
  // TODO history.option.NOT_SETと同じ動作になるようにする
  // TODO 画面遷移方法は要検討
  if (returnPath) {
    navigate(returnPath);
    return;
  }
  navigate(-1); // ブラウザバック
}

BackButton.propTypes = {
  props: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  doShowMessage: PropTypes.func,
  dirty: PropTypes.bool,
  isModified: PropTypes.bool,
  showWarning: PropTypes.bool,
  style: PropTypes.object,
  fullWidth: PropTypes.bool,
  onCheckGrid: PropTypes.func,
  navigate: PropTypes.func,
  label: PropTypes.string,
  returnPath: PropTypes.string,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(withRouter(BackButton));
